// For conversation between iframe and another site
export default (function () {
    let interval_id = null;
    let last_hash = null;
    let cache_bust = 1;
    let attached_callback = null;
    let url;
    return {
        postMessage: function (message) {
            const targetUrl = '*';
            // target = target || parent; // default to parent
            const iframe = document.getElementById('surveybot_widget_iframe');
            const target = iframe.contentWindow;
            // console.log(target.contentWindow, targetUrl);
            if (window['postMessage']) {
                target['postMessage'](message, targetUrl);
            }
            else {
                window.console.log('target_url = ', targetUrl);
                target['location'].href =
                    targetUrl.replace(/#.*$/, '') +
                        '#' +
                        +new Date() +
                        cache_bust++ +
                        '&' +
                        message;
            }
        },
        subscribeOnMessages: function (callback, source_origin = this.url) {
            if (source_origin) {
                this.url = source_origin;
            }
            // browser supports window.postMessage
            if (window['postMessage']) {
                // bind the callback to the actual event associated with window.postMessage
                if (callback) {
                    attached_callback = function (e) {
                        if ((typeof source_origin === 'string' &&
                            e.origin !== source_origin) ||
                            (Object.prototype.toString.call(source_origin) ===
                                '[object Function]' &&
                                source_origin(e.origin) === !1)) {
                            return !1;
                        }
                        callback(e);
                    };
                }
                if (window['addEventListener']) {
                    window[callback ? 'addEventListener' : 'removeEventListener']('message', attached_callback, !1);
                }
                else {
                    window[callback ? 'attachEvent' : 'detachEvent']('onmessage', attached_callback);
                }
            }
            else {
                // a polling loop is started & callback is called whenever the location.hash changes
                interval_id && clearInterval(interval_id);
                interval_id = null;
                if (callback) {
                    interval_id = setInterval(function () {
                        const hash = document.location.hash, re = /^#?\d+&/;
                        if (hash !== last_hash && re.test(hash)) {
                            last_hash = hash;
                            callback({ data: hash.replace(re, '') });
                        }
                    }, 100);
                }
            }
        }
    };
})();
